
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import ListProducts from './ListProducts';


function Index({dishs2, setShowHappy}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

     const [showSpecials, setShowSpecials] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [menus, setMenus] = useState([]);
    const [showCognac, setShowCognac] = useState(false);
    const [showTequila, setShowTequila] = useState(false);
    const [showAguardiente, setShowAguardiente] = useState(false);
    const [showWhiskey, setShowWhiskey] = useState(false);
    const [showGin, setShowGin] = useState(false);
    const [showRum, setShowRum] = useState(false);
    const [showWine, setShowWine] = useState(false);
    const [showVodka, setShowVodka] = useState(false);

     useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
     }, []);
    
    
    useEffect(() => {
        menus.map((item) => {
            if (item.id === 886) {
                setShowCognac(item);
            }
            if (item.id === 887) {
                setShowTequila(item);
            }
            if (item.id === 888) {
                setShowAguardiente(item);
            }
            if (item.id === 889) {
                setShowWhiskey(item);
            }
            if (item.id === 890) {
                setShowGin(item);
            }
            if (item.id === 891) {
                setShowRum(item);
            }
            if (item.id === 892) {
                setShowWine(item);
            }
            if (item.id === 893) {
                setShowVodka(item);
            }
        });
    }, [menus]);

    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{
                    padding: '0 20px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    gap: 12,
                    paddingTop: 100
                }}>
                    


                    <div
                                                onClick={() => {
                            setShowListProduct(true)
                            setdishs(showCognac)
                                                    
                                                }}
                                                style={{
                                                    width: 240,
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                            width: '70%',
                                                            height: 80,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                         Cognac
                                                        </p>
                                                </div>
                                            
                    </div>
                    <br/>
                    <div
                                                onClick={() => {
                                                setShowListProduct(true)
                                                setdishs(showTequila)
                                                    
                                                }}
                                                style={{
                                                    width: 240,
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                            width: '70%',
                                                            height: 80,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                        Tequila
                                                        </p>
                                                </div>
                                            
                    </div>
                    <br />

                    <div
                                                onClick={() => {
                                                   setShowListProduct(true)
                                                   setdishs(showAguardiente)
                                                    
                                                }}
                                                style={{
                                                    width: 240,
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                            width: '70%',
                                                            height: 80,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                         Aguardiente
                                                        </p>
                                                </div>
                                            
                    </div>
                    
                    

                    <div
                                                onClick={() => {
                                               setShowListProduct(true)
                                               setdishs(showWhiskey)
                                                    
                                                    
                                                }}
                                                style={{
                                                    width: 240,
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                          width: '70%',
                                                            height: 80,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                        Whiskey    
                                                        </p>
                                                </div>
                                            
                    </div>


                    <div
                        onClick={() => {
                            setShowListProduct(true)
                            setdishs(showGin)
                                                }}
                                                style={{
                                                    width: 240,
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                          width: '70%',
                                                            height: 80,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                        GIN    
                                                        </p>
                                                </div>
                                            
                    </div>

                    <div
                                                onClick={() => {
                                              setShowListProduct(true)
                                              setdishs(showRum)
                                                    
                                                    
                                                }}
                                                style={{
                                                    width: 240,
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                          width: '70%',
                                                            height: 80,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                        RUM    
                                                        </p>
                                                </div>
                                            
                    </div>


                    <div
                                                onClick={() => {
                                                setShowListProduct(true)
                                                setdishs(showWine)
                                                    
                                                    
                                                }}
                                                style={{
                                                    width: 240,
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                          width: '70%',
                                                            height: 80,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                        VINO    
                                                        </p>
                                                </div>
                                            
                    </div>

                    <div
                                                onClick={() => {
                                                    setShowListProduct(true)
                                                setdishs(showVodka)
                                                    
                                                }}
                                                style={{
                                                    width: 240,
                                                    height: 75,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 5,
                                                    display: 'flex',
                                                    marginTop: 22
                                                }}>
                                                
                                                <div style={{
                                                    display: 'flex', justifyContent: 'center',
                                                    position: 'relative',
                                                    alignItems: 'center',}}>
                                                        <img  onContextMenu={(e) => e.preventDefault()}  src={require('./assets/btn.png')} style={{
                                                          width: '70%',
                                                            height: 80,
                                                              pointerEvents: 'none',
                                                    
                                                        }} />
                                                        <p
                                                            style={{
                                                            fontSize: 20,
                                                            color: 'white',
                                                            textTransform: 'uppercase',
                                                            textAlign: 'center',
                                                            paddingHorizontal: 30,
                                                            position: 'absolute',
                                                            fontFamily: 'Poltawski',
                                                        }}>
                                                        VODKA    
                                                        </p>
                                                </div>
                                            
                    </div>
                    

                </div>

                {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
                />}
              
               
              
                 {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
            </LayoutContent>
        </div>
    );
}
export default Index;